// src/components/ErrorBoundary.jsx
import { Component } from 'react';

const C = { navy: '#122326', slate: '#213A3E', gold: '#BF6847', warm: '#F7F6F3', red: '#c0392b' };

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled error:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexDirection: 'column', gap: 16, background: C.warm, padding: 24,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 40 }}>⚠️</div>
        <h2 style={{ fontFamily: "'Georgia', serif", fontSize: 22, color: C.navy, margin: 0 }}>
          Something went wrong
        </h2>
        <p style={{ fontSize: 14, color: C.slate, maxWidth: 400, lineHeight: 1.6, margin: 0 }}>
          An unexpected error occurred. Please refresh the page. If the problem persists, contact PADD staff.
        </p>
        {this.state.error?.message && (
          <code style={{ fontSize: 12, color: C.red, background: '#fde8e8', padding: '6px 12px', borderRadius: 6 }}>
            {this.state.error.message}
          </code>
        )}
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: 8, padding: '10px 28px', borderRadius: 8, fontSize: 14, fontWeight: 600,
            background: C.gold, color: '#fff', border: 'none', cursor: 'pointer',
          }}
        >
          Refresh Page
        </button>
      </div>
    );
  }
}
